import {
  GET_BRANCHES,
  GET_BRANCHES_FAIL,
  GET_BRANCHES_SUCCESS,
  ADD_NEW_BRANCH,
  ADD_BRANCH_SUCCESS,
  ADD_BRANCH_FAIL,
  UPDATE_BRANCH,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAIL,
  DELETE_BRANCH,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAIL,
  
} from "./actionTypes";

export const getBranches = () => ({
  type: GET_BRANCHES,
})

export const getBranchesSuccess = branchs => ({
  type: GET_BRANCHES_SUCCESS,
  payload: branchs,
})

export const getBranchesFail = error => ({
  type: GET_BRANCHES_FAIL,
  payload: error,
})

export const addNewBranch = data => ({
  type: ADD_NEW_BRANCH,
  payload: data,
})

export const addBranchSuccess = branch => ({
  type: ADD_BRANCH_SUCCESS,
  payload: branch,
})

export const addBranchFail = error => ({
  type: ADD_BRANCH_FAIL,
  payload: error,
})

export const updateBranch = branch => ({
  type: UPDATE_BRANCH,
  payload: branch,
})

export const updateBranchSuccess = branch => ({
  type: UPDATE_BRANCH_SUCCESS,
  payload: branch,
})

export const updateBranchFail = error => ({
  type: UPDATE_BRANCH_FAIL,
  payload: error,
})

export const deleteBranch = data => ({
  type: DELETE_BRANCH,
  payload: data,
})

export const deleteBranchSuccess = data => ({
  type: DELETE_BRANCH_SUCCESS,
  payload: data,
})

export const deleteBranchFail = error => ({
  type: DELETE_BRANCH_FAIL,
  payload: error,
})

